import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import { Typography, Grid } from '@mui/material';
import 'react-quill/dist/quill.snow.css'; // Certifique-se de que o CSS do Quill está importado corretamente

interface ITextEditor {
    id: string;
    label: string;
    placeholder?: string;
    obj?: any;
    value: any;
    setValue: (value: any) => void;
}

export const TextEditor: React.FC<ITextEditor> = ({
    id,
    label,
    placeholder,
    obj,
    value,
    setValue,
}) => {
    const [theme] = useState('snow');

    const handleChange = (html: string) => {
        setValue(obj ? { ...obj, [id]: html } : html);
    };

    return (
        <React.Fragment>
            <Grid item xs={12} md={12}>
                <Typography sx={{ fontSize: 12 }} color='text.secondary' gutterBottom>
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
                <ReactQuill
                    id={id}
                    theme={theme}
                    onChange={handleChange}
                    value={value}
                    modules={modules}
                    formats={formats}
                    bounds={'.app'}
                    placeholder={placeholder}
                    readOnly={false}
                />
            </Grid>
        </React.Fragment>
    );
};

const myColors = [
    '#101246',
    '#5BB2DD',
    '#FF5C5C',
    '#FFC1AD',
    '#B09ECC',
    '#004A6D',
    '#00ABCB',
    'white'
];

const modules = {
    toolbar: [
        [{ 'font': [] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'], // negrito, itálico, sublinhado, riscado
        [{ 'color': myColors }, { 'background': myColors }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'align': [] }],
        [{ 'indent': '-1' }, { 'indent': '+1' }], // identação
        ['blockquote', 'code-block'], // bloco de citação, bloco de código
        ['link', 'image', 'video'], // links, imagens e vídeos
        ['clean'] // remove formatação
    ],
    clipboard: {
        matchVisual: false,
    }
};

const formats = [
    'font', 'header', 
    'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block',
    'list', 'bullet', 'indent', 'align', 
    'link', 'image', 'video', 'color', 'background'
];

// Estilos personalizados para o editor e toolbar
const styles = `
body {
  background: #F5F7FA;
  font-family: "Open Sans", sans-serif;
}

.app {
  margin: 1rem 4rem;
}

.app .ql-container {
  border-bottom-left-radius: 0.5em;
  border-bottom-right-radius: 0.5em;
  background: #FFFFFF;
  border-color: #D8E2EA;
}

.ql-toolbar .ql-icon {
  color: #101246;
}

.app .ql-snow.ql-toolbar {
  display: block;
  border-top-left-radius: 0.5em;
  border-top-right-radius: 0.5em;
  border-color: #D8E2EA;
  background: #FFFFFF;
}

.app .ql-bubble .ql-editor {
  border: 1px solid #D8E2EA;
  border-radius: 0.5em;
}

.app .ql-editor {
  min-height: 18em;
}

.themeSwitcher {
  margin-top: 0.5em;
  font-size: small;
}
`;

// Adiciona o CSS na página
const styleSheet = document.createElement('style');
styleSheet.type = 'text/css';
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default TextEditor;
